import dayjs from 'dayjs';
import { Coordinates } from '../coordinates.model';
import { INommable } from '../nommable.interface';
import { UserEvent } from './user-event.model';

export class AnomalieRondePonctuelleEvent extends UserEvent {
  public static readonly NAME = 'ANOMALIE_RONDE_PONCTUELLE';

  constructor(
    public texte: string | undefined,
    public photos: string[],
    instant?: dayjs.Dayjs,
    coordinates?: Coordinates,
    public signature?: string,
    public idZone?: string,
    public siteId?: string,
    public tourneeId?: string,
    public site?: INommable,
    public avecZone = false
  ) {
    super(AnomalieRondePonctuelleEvent.NAME, instant, coordinates);
  }

  public static hydrate(obj: AnomalieRondePonctuelleEvent): AnomalieRondePonctuelleEvent {
    return new AnomalieRondePonctuelleEvent(
      obj.texte,
      obj.photos ? [...obj.photos] : [],
      dayjs(obj.instant),
      obj.coordinates,
      obj.signature,
      obj.idZone,
      obj.siteId,
      obj.tourneeId,
      obj.site,
      obj.avecZone
    );
  }
}
